import clsx from 'clsx';
import * as React from 'react';
import { IconLoader } from 'ui';
import styles from './side-menu.module.css';

interface SideMenuProps {
    ariaLabel?: string;
    ariaLabelledBy?: string;
    collapseLabel: string;
    expandLabel: string;
    collapsible?: boolean;
    defaultExpanded?: boolean;
    fullWidth?: boolean;
    children: React.ReactNode;
}

export const SideMenu = React.forwardRef<HTMLElement, SideMenuProps>(function SideMenu(props, ref) {
    const { ariaLabel, ariaLabelledBy, collapseLabel, expandLabel, children } = props;
    const { collapsible = true, defaultExpanded = true, fullWidth = false } = props;
    const [collapsed, setCollapsed] = React.useState(!defaultExpanded);
    const contentId = React.useId();

    return (
        <nav
            ref={ref}
            aria-label={ariaLabel}
            aria-labelledby={ariaLabelledBy}
            className={clsx(
                styles['sidebar-root'],
                collapsed ? styles['sidebar-collapsed'] : styles['sidebar-expanded'],
                fullWidth && styles['sidebar-full-width'],
            )}
        >
            {collapsible && (
                <button
                    type="button"
                    onClick={() => setCollapsed(!collapsed)}
                    className={styles['collapse-button']}
                    aria-label={collapsed ? expandLabel : collapseLabel}
                    aria-expanded={!collapsed}
                    aria-controls={contentId}
                >
                    <IconLoader
                        iconName={collapsed ? 'IconChevronRight' : 'IconChevronLeft'}
                        size="sm"
                        className={styles['collapse-icon']}
                    />
                </button>
            )}
            <div id={contentId} className={styles['sidebar-content']}>
                {children}
            </div>
        </nav>
    );
});
